module.exports = __webpack_public_path__ + "static/media/Mushroom_silver.07709789.png";